import React, { useState, useCallback, useRef } from 'react'
import AuthLayout from './auth-layout'
import LoginMobile from 'custom/assets/landing/login-mobile.svg'
import { Formik, Form, Field } from 'formik'
import NeoInput from '../../components/NeoInput/NeoInput'
import InputError from '../../components/InputError/InputError'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useModal } from 'react-modal-hook'
import Modal from '../../components/Modal/Modal'
import { LoginSchema } from '../../schemas/auth'
import NeoButton from '../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import validationConfig from 'custom/config/validation.config.json'
const resetPasswordConfig=validationConfig['resetPassword']

import {
  setCompanyDetails,
  setLoginDetails,
  setMenuDetails,
  setRoleAccessDetails,
  setRoleAccessKey,
  setUserDetails,
} from '../../store/actions/app.actions'
import AuthService from '../../services/auth.service'
import { resetPasswordSchema } from '../../schemas/auth'
import NotificationService from '../../services/notification.service'
import {RESET_PASSWORD_KEYS, BUTTON_KEYS} from "../../utils/translation-constants"
import { useTranslation } from 'react-i18next';

export default function ResetPassword() {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const {t}=useTranslation()

  const onSubmit = useCallback(async (values, { setSubmitting }) => {
    try {
      setLoading(true)
      setSubmitting(true)
      const response = await AuthService.postResetPassword(values)
      if (response.status === 200) {
        NotificationService.showSuccessMessage(response.data['message'])
        history.push('/login')
      }
    } catch (err) {
      setLoading(false)
      setSubmitting(false)
    }
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='45px' height='45px' />
      </div>
    )
  }

  return (
    <AuthLayout>
      <div className='text-center'>
        <img
          className=''
          style={{ margin: '0 auto' }}
          src={LoginMobile}
          alt='mobile logo'
          height='100'
        />
      </div>

      <p className='verify-otp-text'>{t(RESET_PASSWORD_KEYS.TITLE)}</p>

      <div className='mx-auto' style={{ width: 320 }}>
        <Formik
          initialValues={{ otp: '' }}
          validationSchema={resetPasswordSchema}
          onSubmit={onSubmit}>
          {({ isSubmitting, errors, values, touched, handleChange, setFieldValue }) => {
            return (
              <Form>
                <div className='d-flex row'>
                  <div className='col-12'>
                    <div className='form-group my-2'>
                      <label className='control-label'>{t(RESET_PASSWORD_KEYS.NEW_PASSWORD)} {resetPasswordConfig['isNewPasswordRequired'] ? '*' : ''}</label>
                      <Field
                        as='input'
                        name='newPassword'
                        className='form-control'
                        type='password'
                        maxLength='13'
                      />
                      <InputError text={errors.newPassword} touched={touched.newPassword} />
                    </div>
                    <div className='form-group mt-3'>
                      <label className='control-label'>{t(RESET_PASSWORD_KEYS.CONFIRM_PASSWORD)} {resetPasswordConfig['isConfirmNewPasswordRequired'] ? '*' : ''}</label>
                      <Field
                        as='input'
                        name='confirmPassword'
                        className='form-control'
                        type='password'
                        maxLength='13'
                      />
                      <InputError
                        text={errors.confirmPassword}
                        touched={touched.confirmPassword}
                        type='password'
                      />
                    </div>
                    <div className='mt-4 ml-auto px-0'>
                      {isSubmitting ? (
                        renderLoading()
                      ) : (
                        <NeoButton type='submit' text={t(BUTTON_KEYS.RESET)} mode='newDesign' />
                      )}
                    </div>
                  </div>
                  {/* <div className='col-12  mt-4'>
                    <div className='card passwordCriteria'>
                      <div className='card-body'>
                        <h6 className='card-title row mx-3'>New Password Criteria</h6>
                        {criteriaList.map((value, i) => (
                          <p className='card-text col' key={i}>
                            {value.description} : <b>{value.value}</b>
                          </p>
                        ))}
                      </div>
                    </div>
                  </div> */}
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
      <div style={{ height: 100 }}></div>
    </AuthLayout>
  )
}
